import { IMG_CDN_URL } from "../constants";
import { AiFillClockCircle } from "react-icons/ai";
import { HiCurrencyRupee } from "react-icons/hi";

const RestaurantSummary = ({ restaurant }) => {

  return (
    <div className="flex flex-col justify-center bg-gray-950 text-white sm:flex-row mb-4">
      <div className="p-5 sm:h-64">
        <img
          className="h-full w-full rounded-md"
          src={IMG_CDN_URL + restaurant.cloudinaryImageId}
        />
      </div>

      <div className="p-5 sm:basis-72">
        <h2 className="text-2xl text-slate-200 font-medium mb-4">
          {restaurant.name}
        </h2>
        <h6 className="text-sm">{restaurant.cuisines.join(",")}</h6>
        <h6 className="text-sm">
          {restaurant.areaName}, {restaurant.sla?.lastMileTravelString}
        </h6>
        <div className="flex flex-col items-center px-1 my-6 bg-slate-50 text-xs font-semibold text-black rounded-sm w-fit">
          <h6
            className="border-b py-1"
            style={{
              color: restaurant.avgRating >= 4 ? "green" : "#B8860B",
            }}
          >
            &#9733; {restaurant.avgRating}
          </h6>
          <h6 className="py-1">{restaurant.totalRatingsString}</h6>
        </div>
        <div className="flex justify-between text-sm font-medium">
          <h4 className="flex items-center">
            <span className="mr-1">
              <AiFillClockCircle />
            </span>
            <span>{restaurant.sla?.deliveryTime} mins</span>
          </h4>
          <h4 className="flex items-center">
            <span className="mr-1">
              <HiCurrencyRupee />
            </span>
            <span>{restaurant.costForTwoMessage}</span>
          </h4>
        </div>
      </div>
    </div>
  );
};

export default RestaurantSummary;
